import React from 'react';
import classnames from 'classnames';
import Label from './forms/Label';
import Helptext from './FormHelptext';

export default function FormGroup({
  className,
  label,
  labelHtmlFor,
  labelClassName,
  children,
  helptext,
}) {
  return (
    <div className={classnames(className)}>
      <Label htmlFor={labelHtmlFor} className={labelClassName}>
        {label}
      </Label>
      {children}
      {helptext && <Helptext className="mt-1">{helptext}</Helptext>}
    </div>
  );
}
